module.exports = __webpack_public_path__ + "img/holiday-inn-express-lisbon-alfragide.e683476b.jpg";